export * from './searchResultsMapper';
